import { db } from "./firebase";
import { collection, addDoc, serverTimestamp, query, orderBy, limit, getDocs, where } from "firebase/firestore";

export interface AuditLog {
    id?: string;
    action: string;
    details: string;
    userId: string;
    userEmail: string;
    labId: string;
    timestamp: any;
    ipAddress?: string; // Optional, might need an external service to get this client-side
}

export const logAction = async (
    labId: string,
    userId: string,
    userEmail: string,
    action: string,
    details: string
) => {
    try {
        await addDoc(collection(db, "audit_logs"), {
            labId,
            userId,
            userEmail,
            action,
            details,
            timestamp: serverTimestamp(),
        });
    } catch (error) {
        console.error("Error logging action:", error);
    }
};

export const getAuditLogs = async (labId: string, limitCount = 100) => {
    try {
        const q = query(
            collection(db, "audit_logs"),
            where("labId", "==", labId),
            orderBy("timestamp", "desc"),
            limit(limitCount)
        );
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as AuditLog));
    } catch (error) {
        console.error("Error fetching audit logs:", error);
        return [];
    }
};
